import { ConnStateInfo } from "@/sdk"
import { RootState } from "@/store"
import { VideoStatsUseCase } from "@/usecases/video_statistic"
import {
  NetworkQualityMonitor,
  type NetworkQualityState,
} from "@/usecases/network_quality"
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"

interface ConnStatisticInfo {
  rtt: number
  fps: number
  byteReceived: number
  lostRate: number
  resolution: string
  isPlayingAudio: boolean
  networkQuality: NetworkQualityState
}

const networkQualityMonitor = new NetworkQualityMonitor()

const initialState: ConnStatisticInfo = {
  rtt: 0,
  fps: 0,
  byteReceived: 0,
  lostRate: 0,
  resolution: "",
  isPlayingAudio: false,
  networkQuality: networkQualityMonitor.reset(),
}

const ConnStatsSlice = createSlice({
  name: "connStats",
  initialState,
  reducers: {
    // 更新连接状态
    updateConnStats: (state, action: PayloadAction<ConnStateInfo>) => {
      const { inputVideoData, otherData } = action.payload
      state.rtt = Number.isFinite(otherData.rtt) ? Math.trunc(otherData.rtt) : 0
      state.fps = inputVideoData.fps
      state.byteReceived = (inputVideoData.curBytesReceived * 8) / 1024 / 1024
      state.lostRate = inputVideoData.lostRate * 100
      state.networkQuality = networkQualityMonitor.update(
        otherData.rtt,
        state.lostRate
      )
      if (inputVideoData.frameWidth > 0 && inputVideoData.frameHeight > 0) {
        state.resolution = `${inputVideoData.frameWidth} x ${inputVideoData.frameHeight}`
      }
      state.isPlayingAudio = otherData.isPlayingAudio
    },
    // 停止视频统计
    stopGetConnStats: (state) => {
      VideoStatsUseCase.stopGatheringData()
      state.rtt = 0
      state.fps = 0
      state.byteReceived = 0
      state.lostRate = 0
      state.resolution = ""
      state.isPlayingAudio = false
      state.networkQuality = networkQualityMonitor.reset()
    },
  },
  extraReducers: {},
})

export const { stopGetConnStats, updateConnStats } = ConnStatsSlice.actions

// 开始获取状态信息
export const startGetConnStats = createAsyncThunk(
  "connStats/start",
  (_, { dispatch }) => {
    VideoStatsUseCase.starGatheringData((connStats) => {
      dispatch(updateConnStats(connStats))
    })
  }
)

export const selectConnStats = (state: RootState) => {
  return state.connStats
}

export default ConnStatsSlice.reducer
